export const igFunnelData = [
  {
    path: "true-classic-ig",
    title: "True Classic's $250M Funnel",
    videoEmbedUrl: "https://www.youtube.com/embed/bX6gFc1Ee2M",
    downloadUrl:
      "https://drive.google.com/file/d/1l23NUpZ3Ii1dUy28_qvvKkAYtgiLBO5z/view?usp=sharing",
  },
  {
    path: "5-phase-launch",
    title: "Why the Prime Model is Broken for Most Creators",
    videoEmbedUrl: "https://www.youtube.com/embed/fFNICn8wIbw",
    downloadUrl:
      "https://drive.google.com/file/d/1ODRKhMg--p_EXFgLOb17BGefcpvisNr1/view?usp=sharing",
  },
];
